export const routeNames = {
  Error401: 'Error401',
  Error403: 'Error403',
  Error404: 'Error404',
  Error500: 'Error500',
  Login: 'Login',
  Home: 'Home',
  Welcome: 'Welcome',
  Dashboard: 'dashboard',
  DashboardCashFlowDetail: 'dashboard/cash-flow-detail/detail',
  DashboardCostEstimateDetail: 'dashboard/cost-estimate-detail/detail',

  TaskAssign: 'TaskAssign',
  TaskAlert: 'TaskAlert',
  TaskAlertDetail: 'TaskAlertDetail',
  BalanceManagement: 'BalanceManagement',

  ProjectManagement: 'pm',
  ProjectList: 'pm/project',
  ProjectCreate: 'pm/project/create',
  ProjectDetail: 'pm/project/detail',
  ProjectEdit: 'pm/project/edit',
  ProjectAccountingYearReport: 'pm/report/project-financial-year-report',
  ProjectAppraisal: 'pm/appraisal',
  ProjectAppraisalCreate: 'pm/appraisal/create',
  ProjectAppraisalDetail: 'pm/appraisal/detail',
  ProjectAppraisalEdit: 'pm/appraisal/edit',
  ProjectAppraisalDelete: 'pm/appraisal/delete',

  ProjectAggregationCycle: 'pm/aggregation-cycle',

  DraftProject: 'pm/draft-project',

  TaskManagement: 'tm',
  TaskList: 'tm/task/list',
  TaskCreate: 'tm/task/create',
  TaskDetail: 'tm/task/detail',
  TaskEdit: 'tm/task/edit',

  ContractorManagement: 'cm',
  ContractorList: 'cm/contractor/list',

  ContractManagement: 'contract-management',
  ContractList: 'contract-management/list',
  ContractCreate: 'contract-management/create',
  ContractDetail: 'contract-management/detail',
  ContractEdit: 'contract-management/edit',

  ProfileManagement: 'profile-management',

  Settings: 'settings',
  SettingsMenuList: 'settings/index',
  SettingsCheckList: 'settings/check-list',
  SettingsCheckListDetail: 'settings/check-list/detail',
  SettingsProjectType: 'settings/global-list-detail/project-type',
  SettingsObjectiveType: 'settings/global-list-detail/objective-type',
  SettingsBudgetType: 'settings/global-list-detail/budget-type',
  SettingsInvestType: 'settings/global-list-detail/invest-type',
  SettingsCapitalType: 'settings/global-list-detail/capital-type',
  SettingsImportant: 'settings/global-list-detail/important',
  SettingsCloseProject: 'settings/global-list-detail/close-project',

  SettingsContractorType: 'settings/global-list-detail/contractor-type',
  SettingsLegalType: 'settings/global-list-detail/legal-type',
  SettingsTaskState: 'settings/global-list-detail/task-state',
  SettingsTaskPriority: 'settings/global-list-detail/task-priority',
  SettingAppraisalList: 'settings/appraisal-list',
}
